import React, { PureComponent } from "react";
import VisibilitySensor from "react-visibility-sensor";

import { TTP_HOME_URL } from "Config";
import styles from "./Pellet.local.scss";
import classnames from "classnames";
import _ from "i18n";

export default class PelletComponent extends PureComponent {
  state = {
    listElement: null
  };

  componentDidMount() {
    setTimeout(() => {
      const listElement = document.getElementById("pellets-list");
      this.setState({ listElement });
    });
  }

  loadMore = isVisible => {
    const { pellets } = this.props;
    if (!isVisible || (pellets && pellets.length === 1)) {
      return;
    }

    if (this.props.loadMore) {
      this.props.loadMore();
    }
  };

  renderTooltip(type, label, data, id) {
    return (
      <div className={classnames(styles.tooltip, styles[type.toLowerCase()])}>
        <h5>{label}</h5>
        <ul>
          {data.map(d => (
            <li key={d.label}>
              <span className={styles.label}>{d.label}</span>
              <span className={classnames(styles.circle, d.bg ? d.bg : "")}>
                {d.value}
              </span>
            </li>
          ))}
        </ul>
        {/*}<a
          href={`${TTP_HOME_URL}/btb-app-login-url?organizationId=${id}`}
          target="_blank"
        >
          <i className={classnames(styles.forward, "icon icon-action-redo")} />
        </a>*/}
      </div>
    );
  }

  displayTooltip = (type, e) => {
    /*$(e.target)
      .parents("." + styles.pellet_details)
      .find("." + styles[type.toLowerCase()])
      .show();*/
  };

  renderFetching() {
    const { fetching } = this.props;

    if (!fetching) {
      return;
    }

    return (
      <React.Fragment>
        <li className={styles.fetching}>
          <span />
        </li>
        <li className={styles.fetching}>
          <span />
        </li>
        <li className={styles.fetching}>
          <span />
        </li>
        <li className={styles.fetching}>
          <span />
        </li>
        <li className={styles.fetching}>
          <span />
        </li>
        <li className={styles.fetching}>
          <span />
        </li>
      </React.Fragment>
    );
  }

  renderPellets() {
    const { pellets = [] } = this.props;

    return (
      <ul id="pellets-list">
        {pellets.map(pellet => {
          const { btbStats, uen, id, abbreviation, name } = pellet;
          if (!btbStats) {
            return null;
          }
          const {
            aPBookedSum,
            aPForwardedSum,
            aPToAcceptSum,
            aRBookedSum,
            aRForwardedSum,
            aRToAcceptSum,
            delays
          } = btbStats;

          const { bwn2And5, gt5, lt2 } = delays;

          let bg = styles.green;
          let value = lt2;
          if (gt5 > 0) {
            bg = styles.red;
            value = gt5;
          } else if (bwn2And5 > 0) {
            bg = styles.yellow;
            value = bwn2And5;
          }

          return (
            <li key={abbreviation ? abbreviation : name} className="grid-x">
              <span className="cell small-4">BE {uen}</span>
              <span className="cell small-4">
                {abbreviation ? abbreviation : name}
              </span>
              <div
                className={classnames(styles.pellet_details, "cell small-4")}
              >
                <a
                  href={`${TTP_HOME_URL}/btb-app-login-url?organizationId=${id}`}
                  target="_blank"
                >
                  <img
                    src="/img/icons/pellet-go.svg"
                    alt=""
                    className={classnames(styles.forward)}
                  />
                </a>
                <ul>
                  <li onMouseEnter={this.displayTooltip.bind(this, "PURSHASE")}>
                    <img
                      className={styles.lforword}
                      src="/img/icons/forward-left.svg"
                      alt=""
                    />
                    <img
                      className={classnames(styles.doc, styles.doc_left)}
                      src="/img/icons/doc.svg"
                      alt=""
                    />
                    <span>{aPToAcceptSum}</span>
                    {this.renderTooltip(
                      "PUCHASE",
                      _("Purchase invoices"),
                      [
                        { label: _("To accept"), value: aPToAcceptSum },
                        { label: _("Forwarded"), value: aPForwardedSum },
                        { label: _("Booked"), value: aPBookedSum }
                      ],
                      id
                    )}
                  </li>
                  <li onMouseEnter={this.displayTooltip.bind(this, "SALES")}>
                    <img
                      className={styles.rforword}
                      src="/img/icons/forward-right.svg"
                      alt=""
                    />
                    <img
                      className={styles.doc}
                      src="/img/icons/doc.svg"
                      alt=""
                    />
                    <span>{aRToAcceptSum}</span>
                    {this.renderTooltip(
                      "SALES",
                      _("Sales invoices"),
                      [
                        { label: _("To accept"), value: aRToAcceptSum },
                        { label: _("Forwarded"), value: aRForwardedSum },
                        { label: _("Booked"), value: aRBookedSum }
                      ],
                      id
                    )}
                  </li>
                  <li
                    className={classnames(styles.colored, bg)}
                    onMouseEnter={this.displayTooltip.bind(this, "DELAY")}
                  >
                    <img
                      alt=""
                      src={`/img/icons/${
                        bg === styles.red ? "red-flag" : "green-flag"
                      }.svg`}
                    />
                    <span>{value}</span>
                    {this.renderTooltip(
                      "DELAY",
                      _("Invoices to accept"),
                      [
                        {
                          label: _("More than 5 days"),
                          value: gt5,
                          bg: styles.red
                        },
                        {
                          label: _("Between 5 and 2 days"),
                          value: bwn2And5,
                          bg: styles.yellow
                        },
                        {
                          label: _("Less than 2 days"),
                          value: lt2,
                          bg: styles.green
                        }
                      ],
                      id
                    )}
                  </li>
                </ul>
              </div>
            </li>
          );
        })}

        {this.renderFetching()}
        {this.renderVisibilitySensore()}
      </ul>
    );
  }

  renderVisibilitySensore = () => {
    if (!this.state.listElement || !this.props.hasMore || this.props.fetching) {
      return;
    }

    return (
      <VisibilitySensor onChange={this.loadMore}>
        {({ isVisible }) => (
          <li className="grid-x" style={{ visibility: "hidden" }}>
            <span className="cell small-4" style={{ height: "1.5rem" }}>
              VisibilitySensor is {isVisible ? "visible" : "invisible"}
            </span>
          </li>
        )}
      </VisibilitySensor>
    );
  };

  render() {
    return (
      <div className={classnames(styles.pellet)}>
        <div className={classnames(styles.details)}>
          <div className={classnames(styles.header, "grid-x")}>
            <span className="cell small-4">
              {_("N° d'entreprise à la BCE")}
            </span>
            <span className="cell small-4">{_("Organisation")}</span>
            <span className="cell small-4">{_("Billtobox")}</span>
          </div>
          {this.renderPellets()}
        </div>
      </div>
    );
  }
}

// Conn



// WEBPACK FOOTER //
// ./src/components/Community/WorkPlace/Pellet/PelletComponent.js